/* global window, document, Tabulator */

(function (window, document) {
    var root = document.getElementById('radar-emergenti-root');
    if (!root) return;

    function qs(sel, el) { return (el || document).querySelector(sel); }
    function setStatus(msg) { var el = qs('[data-radar-status]', root); if (el) el.textContent = msg || ''; }

    function parseEuroNumber(v) {
        if (v == null || v === '') return NaN;
        if (typeof v === 'number' && isFinite(v)) return v;
        var s = String(v).trim().replace(/\s/g, '');
        if (!s) return NaN;
        if (s.indexOf(',') !== -1 && s.indexOf('.') !== -1) return parseFloat(s.replace(/\./g, '').replace(',', '.'), 10);
        if (s.indexOf(',') !== -1) return parseFloat(s.replace(',', '.'), 10);
        return parseFloat(s, 10);
    }
    function formatEuroIt(v) {
        var n = parseEuroNumber(v);
        if (!isFinite(n)) return '—';
        return n.toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }

    function escHtml(s) {
        if (s == null) return '';
        return String(s)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    function readFilters() {
        var form = qs('[data-radar-filters]', root);
        if (!form) return {};
        var fd = new FormData(form);
        var out = {};
        var lb = fd.get('lookback_days');
        if (lb) out.lookback_days = String(lb).trim();
        return out;
    }

    var apiBase = (root.getAttribute('data-api-base') || '').replace(/\/+$/, '');
    var client = new window.AppaltiMap.ApiGatewayClient({
        baseUrl: apiBase,
        tokenStore: new window.AppaltiMap.TokenStore('appaltimap_auth')
    });

    // Ensure client.get exists
    if (!client.get) {
        client.get = function (url) {
            var token = client.tokenStore.getToken() || '';
            var headers = { Accept: 'application/json' };
            if (token) headers.Authorization = 'Bearer ' + token;
            return fetch(url, { headers: headers }).then(function (r) { if (!r.ok) throw r; return r.json(); });
        };
    }

    var table;
    function buildTable() {
        if (typeof Tabulator === 'undefined') { setStatus('Tabulator non disponibile.'); return; }
        var el = qs('#radar-emergenti-table', root);
        if (!el || table) return;
        table = new Tabulator(el, {
            layout: 'fitColumns',
            placeholder: 'Nessun dato',
            columns: [
                { title: 'Azienda', field: 'canonical_name', minWidth: 200, formatter: function (c) { return '<span>' + escHtml(c.getValue() || '—') + '</span>'; } },
                { title: 'Dim.', field: 'company_size', width: 70 },
                { title: 'Vittorie (recenti)', field: 'recent_wins', width: 140, hozAlign: 'right' },
                { title: 'Part. (recenti)', field: 'recent_participations', width: 140, hozAlign: 'right' },
                { title: 'Vittorie (tot.)', field: 'stats_wins_total', width: 120, hozAlign: 'right' }
            ]
        });
        root._vgTabulator = table;
    }

    function load() {
        buildTable();
        if (!table) return;
        var f = readFilters();
        setStatus('Caricamento…');
        return client.get(apiBase + '/radar/emerging?' + new URLSearchParams(f).toString())
            .then(function (data) {
                table.setData((data && data.items) || []);
                setStatus('');
            })
            .catch(function () { setStatus('Impossibile caricare.'); });
    }

    load();
    var form = qs('[data-radar-filters]', root);
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); load(); });
})(window, document);

